module.exports = __webpack_public_path__ + "static/media/dolly-flatbed-empty.e4255912.svg";